<template>
    <div style="display:flex;flex-wrap:wrap">
		<div class="egInfo" v-for="(item,index) in item">
			<img class="imgSty" :src="item.img">
			<div class="fSty">
				<div class="titSty">{{item.tit}}</div>
				<div class="lSty">
					<div class="lName">{{item.value}}积分</div>
					<div class="lBtn" v-if="val==0" @click="exchange(item)">立即兑换</div>
					<div class="lBtn" v-else style="background:#777">暂无库存</div>
				</div>
			</div>
			<div class="pRect" v-if="val==1">
			</div>
			<div class="bgCir" v-if="val==1">
				<div class="tStyn">暂无库存</div>
				<div class="tStys">sold out</div>
			</div>
		</div>
	</div>
</template>
<script>
    export default{
        props:['item'],
        data(){
            return{
				val:0,
                show:true
            }
        },
        methods:{
			exchange(item){
				this.$emit('exchange',item)
			}
        },
        mounted(){

        },
        created(){
			
        }
    }
</script>
<style scoped>
	.egInfo{
		position:relative;
		flex:0 0 162px;
		height: 251px;
		opacity: 1;
		background: #ffffff;
		border-radius: 4px;
		box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16); 
		margin-bottom:20px;
		box-sizing:border-box;
	}
	.pRect{
		position:absolute;
		top:0;
		left:0;
		background:rgba(0,0,0,.2);
		width:100%;
		height:100%;
	}
	.egInfo:nth-child(even){
		margin-left:11px;
	}
	.imgSty{
		width:100%;
		height:162px;
	}
	.titSty{
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: #000000;
		line-height: 18px;
	}
	.lSty{
		display:flex;
		font-size: 17px;
		font-weight: 400;
		text-align: left;
		margin-top:5px;
		color: #fd7622;
	}
	.lName{
		flex:1
	}
	.lBtn{
		flex:1;
		width: 64px;
		height: 23px;
		line-height:23px;
		opacity: 1;
		background: linear-gradient(180deg,#36b3fe, #0080ff);
		border-radius: 10px;
		font-size:12px;
		text-align:center;
		color:#fff
	}
	.fSty{
		width:100%;
		height:89px;
		padding:0px 7px 8px 7px;
		box-sizing: border-box;
	}
	.bgCir{
		z-index:3000;
		position:absolute;
		top:40%;
		left:50%;
		transform: translate(-50%,-50%);
		width: 84px;
		height: 84px;
		padding:20px 10px;
		box-sizing: border-box;
		background:rgba(0,0,0,.3);
		border-radius: 50%;
	}
	.tStyn{
		opacity: 1;
		font-size: 12px;
		font-weight: 400;
		text-align: center;
		color: #ffffff;
	}
	.tStys{
		opacity: 1;
		font-size: 10px;
		font-weight: 400;
		text-align: center;
		color: #ffffff;
		line-height: 33px;
    }
</style>
